export default __webpack_public_path__ + "static/compareItemImg5-4e75a9354ecd4c5fb476687c61256c75.webp";